<template>
    <div>

        <GenericPostType :postContent="postContent">
                {{postContent.text}}
        </GenericPostType>

    </div>
</template>


<script>
  const fb        = require('@/firebaseConfig.js')
  const CommonLib = require('@/lib/Common')

  import Vue from 'vue'
  import Moment from 'moment'
  import VueTimeago from 'vue-timeago'
  import Likes from '@/components/Likes/Likes'
  import GenericPostType from '@/components/Posts/Types/GenericPostType'

  export default {
    name:       'TextPostType',
    components: {
      Likes,
      GenericPostType,
    },
    props:      [
      'postContent'
    ],
    data ()
    {
      return {

      }
    },
    mounted ()
    {

    },
    filters:    {

    },
    computed:   {

      currentUserProfile ()
      {
        return this.$store.getters.currentUserProfile

      },
      currentUser ()
      {
        return this.$store.getters.currentUser
      },

    },
    methods:    {


    },
    watch:      {
      threadId ()
      {

        var that = this

      }

    }
  }

</script>
<style src="@/pages/Profile/Profile.scss" lang="scss" scoped/>

<style>


</style>
